// React Lib
import classnames from 'classnames';
import React, { useEffect, useState } from "react";


// Component Styles
import Styled from "./UpAndRunningStyles";
import Button from "../Button/Button";
import { Color, ColorSAP, FONT_FAMILY, Typography, ShowMoreVertical } from "../../ontego-ui";
import { Copy, Edit, Delete } from "../../ontego-ui/sap_icons";

import Form from "../Form/Form";
import TertiaryButton from "../TertiaryButton/TertiaryButton";
import { OverflowMenu } from "../OverflowMenu/OverflowMenu";
import Radio from "../Radio/Radio";

import { EditorState } from 'draft-js';
import { useTranslation } from "react-i18next";
import PlusIcon from "../../Icons/PlusIcon";
import { iconSizeTertiaryButtonIcon } from "../../Utils/Utils";
import EditorComponent from "../TextEditor/TextEditor";
import { fontWeight, lineHeight } from '@mui/system';

const NoteRenderer = (props) => {
    // const classes = useStyles(props)
    const { t } = useTranslation()

    const { data, type, onEditNote, onSaveNote, onDeleteNote,
        onCopyNote, addNote, phaseNote, addPhaseNote, cancel, saveNote } = props

    const [editorState, setEditorState] = useState(EditorState.createEmpty())
    const [showEditor, setShowEditor] = useState(false)
    const [isEdit, setIsEdit] = useState(false)

    useEffect(() => {
        setShowEditor(false)
        setEditorState(data.notes)

        if (data.notes.getCurrentContent().hasText()) {
            setShowEditor(true)
            setIsEdit(false)
        }
    }, [])

    const handleAddNewNote = () => {
        setShowEditor(true)
        setIsEdit(true)
    }

    const handleSaveNote = (editorState) => {
        onSaveNote(data, type, editorState)
    }

    const handleDeleteNote = () => {
        onDeleteNote(data, type)
        setShowEditor(false)
    }

    return (
        <Styled.NoteRendererContainer>
            {!showEditor && (
                <TertiaryButton
                    theme="light"
                    size="small"
                    onClick={handleAddNewNote}
                    style={{ color: ColorSAP.primary[70] }}
                    icon={<PlusIcon style={{ marginLeft: 8, width: iconSizeTertiaryButtonIcon("small"), height: iconSizeTertiaryButtonIcon("small"), fill: ColorSAP.primary[70] }} />}
                >
                    {t('dialogs.addNote')}
                </TertiaryButton>
            )}
            {showEditor && (
                <EditorComponent
                    handleSaveChange={handleSaveNote}
                    handleDeleteNotes={handleDeleteNote}
                    editorState={editorState}
                    setEditorState={setEditorState}
                    isEdit={isEdit}
                    setIsEdit={setIsEdit}
                    setShowEditor={setShowEditor}
                />
            )}
        </Styled.NoteRendererContainer>
    )
}

export const UpAndRunning = (props) => {
    const { data = {
        id: "up-running-1",
        name: "Up and Running #",
        timeline: ["90", "120", "Einzelne"],
        selectedTimeline: 90,
        isEditMode: false,
        notes: ""
    }, children, hasChild, onEditNote, onSaveNote, onDeleteNote, onCopyNote, onTimelineChange, addNote = 'Add Note',
        phaseNote = 'Phase Note', addPhaseNote = 'Add Phase Note', cancel = 'Cancel', saveNote = 'Save Note', onEdit, onDelete, style } = props

    const { t } = useTranslation()

    const [anchorEl, setAnchorEl] = useState(null)

    const handleClickShowMoreIcon = (event) => {
        event.stopPropagation();

        if (!anchorEl) {
            setAnchorEl(event.currentTarget)
        }
    }

    return (
        <Styled.UpAndRunningContainer
            id={data.id}
            style={{
                ...style
            }}
        >
            <ShowMoreVertical
                style={{
                    position: 'absolute',
                    top: 16,
                    right: 10,
                    width: 24,
                    height: 24,
                    color: ColorSAP.primary[40],
                    cursor: 'pointer'
                }}
                onClick={handleClickShowMoreIcon}
            />
            <OverflowMenu
                anchorElement={anchorEl}
                setAnchorEl={setAnchorEl}
                // menuItems={menuItem}
                menuItems={[
                    {
                        text: t(`collection.editPhase`),
                        onClick: () => onEdit()
                    },
                    {
                        text: t(`collection.deletePhase`),
                        onClick: () => onDelete(),
                        destructive: true
                    }
                ]}
            />
            <Typography
                fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD}
                size={18}
                color={ColorSAP.neutral[100]}
                style={{ paddingBottom: 16, wordBreak: 'break-word', paddingRight: 24 }}
            >
                {data.name}
            </Typography>
            <Styled.TimelineInputContainer>
                {data.timeline.map((time, index) => (
                    <Radio
                        type="n900"
                        key={index}
                        name={data.id}
                        value={time}
                        label={index < 2 ? `${time} ${t('common.days')}` : `${t('common.individual')}`}
                        checked={data.selectedTimeline === time}
                        onChange={onTimelineChange}
                        style={{ marginRight: index < data.timeline.length - 1 ? 24 : 'auto' }}
                    />
                ))}
            </Styled.TimelineInputContainer>
            {children}
            {!hasChild && (
                <div
                    style={{
                        width: '100%',
                        paddingTop: 24,
                        paddingBottom: 24,
                        textAlign: 'center'
                    }}
                >
                    <>
                        <Typography
                            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD}
                            size={14}
                            color={ColorSAP.neutral[30]}
                            style={{ paddingBottom: 5, fontWeight: 700 }}
                        >
                            {t('collection.noFunctionAssigned')}
                        </Typography>
                        <Typography
                            fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_REGULAR}
                            size={12}
                            color={ColorSAP.neutral[100]}
                        >
                            {t('collection.dragAndDropHere')}
                        </Typography>
                    </>
                </div>
            )}
            <NoteRenderer
                data={data}
                type="UP_AND_RUNNING"
                onEditNote={onEditNote}
                onSaveNote={onSaveNote}
                onDeleteNote={onDeleteNote}
                onCopyNote={onCopyNote}
                addNote={addNote}
                phaseNote={phaseNote}
                addPhaseNote={addPhaseNote}
                cancel={cancel}
                saveNote={saveNote}
            />
        </Styled.UpAndRunningContainer>
    )
}

export default React.memo(UpAndRunning)